import React from "react";
import { Divider as AntDivider } from "antd";
import classNames from "classnames";

export const Divider = ({ className, my }) => {
  return <AntDivider className={classNames(className, my ? my : "my-12")} />;
};
